export default "__VITE_ASSET__edfa0433__"